import React from 'react';
import IconFont from '@meitu/xdesign-icon-font';
import { useLocaleStore } from '@/i18n';
import { useToolbarContext } from '../../hooks/use-toolbar-context';

const REPLACE_IMAGE_EVENT = 'REPLACE_IMAGE_EVENT';

const ReplaceInspector = ({ hideIcon }: { hideIcon?: boolean }) => {
    const { events } = useToolbarContext();

    const { $t } = useLocaleStore();
    const handleReplace = () => {
        events?.emit(REPLACE_IMAGE_EVENT, { way: 'replace_panel' });
    };

    return (
        <React.Fragment>
            <div className="c-header-toolbar-actions__replace" onClick={handleReplace}>
                {!hideIcon && <IconFont name="RedrawBold" fontSize={14} />}
                {$t((v) => v.headerToolbar.replace)}
            </div>
        </React.Fragment>
    );
};

export default React.memo(ReplaceInspector);
